import React from 'react';
import { Link, Outlet } from "react-router-dom";
import logo from '../images/logo-black.png';

const AuthLayout = () => {
  return (
    <div className="auth-layout">

      {/* Same white navbar as DefaultLayout */}
      <nav id="psycle" className="navbar fixed-top">
        <div className="psycle-header-inner">
          <Link to="/" className="psycle-header-logo">
            <img className="logo" src={logo} alt="Psycle" />
          </Link>
        </div>
      </nav>

      <Outlet />
    </div>
  );
}

export default AuthLayout;